import { FunctionComponent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import { Guid } from "../../../api/baseApi";
import { ReorderItemPair } from "../../../api/channelsApi";
import { getMedia, MediaModel, MediaType } from "../../../api/mediaApi";
import { addLeadingZero, formatDuration, getYoutubeImageUrlById, renderMediaType } from "../../../services/common";
import { Button } from "../../components/Button";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import Search from "../../components/search/Search";
import { CenterModal, RightModal, SmallModal } from "../../components/sideModal/Modal";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import InnerLayout from "../innerLayout/InnerLayout";
import { addMediaToPlayNowList, addPlayNowMediaSchedule, changeGroupNameForPlayNowMedia, cloneGroupedPlayNowMedia, cloneGroupPlayNowMedia, createGroupForPlayNowMedia, deletePlayNowMediaSchedule, disableSkinPlayNowMedia, enableSkinPlayNowMedia, getGroupedPlayNowMedia, getGroupsForPlayNowMedia, getPlayNowList, getPlayNowListMedias, getPlayNowMediaSchedule, GroupForPlayNowMediaRequest, GroupPlayNowMedia, PlayNowList, PlayNowListAddMediaRequest, playNowListDeleteMedia, PlayNowListMedia, PlayNowMediaMediaScheduleRequest, PlayNowMediaSchedule, removeGroupPlayNowMedia, ReorderedPlayNowIds, reorderGroupPlayNowMedia, reorderPlayNowListMedia, updateGroupForPlayNowMedia } from "../../../api/playNowListApi"
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";
import { FormInput, FormRow } from "../../components/formRow/FormRow";
import { formatDate, formatTimeOnly } from "../../../services/dateService";
import Select, { MultiValue, SingleValue } from "react-select";
import moment from "moment";
import hiveStackIMG from './../../images/icons/hivestack.jpg';


interface PlayNowMediaParams {
    listId: Guid
}

interface PlayNowListMediaProps {
    logOut: () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type ModalAction = "create" | "update" | "set" | "clone" | "delete" | "nothing" | "cloneMedia" | "deleteMedia";
type Option<T> = { value: T, label: string}
interface CheckedItems {
    [key: string]: boolean;
}

const CurrentPlayListMedia: FunctionComponent<PlayNowListMediaProps> = (props: PlayNowListMediaProps) => {

    let { listId } = useParams<PlayNowMediaParams>();

    let [isLoading, setIsLoading] = useState<boolean>(false);
    let [showMediaModal, setShowMediaModal] = useState<boolean>(false);
    let [playNow, setPlayNow] = useState<PlayNowList | null>(null);

    let [searchString, setSearchString] = useState<string>("");
    let [media, setMedia] = useState<MediaModel[]>([]);
    let [currentPage, setCurrentPage] = useState<number>(1);
    let [selectedMedia, setSelectedMedia] = useState<{ id: string, index: number }[]>([]);
    let [totalDuration, setTotalDuration] = useState<number>(0);

    let [isShowScheduleModal, setIsShowScheduleModal] = useState(false);
    let [mediaPeriodName, setMediaPeriodName] = useState('');
    let [isMediaPeriodNameError, setIsMediaPeriodNameError] = useState(false);
    let [mediaPeriodStart, setMediaPeriodStart] = useState('');
    let [isMediaPeriodStartError, setIsMediaPeriodStartError] = useState(false);
    let [mediaPeriodEnd, setMediaPeriodEnd] = useState('');
    let [isMediaPeriodEndError, setIsMediaPeriodEndError] = useState(false);
    let [mediaPeriodStartTime, setMediaPeriodStartTime] = useState('');
    let [mediaPeriodEndTime, setMediaPeriodEndTime] = useState('');
    let [isMediaPeriodEndTimeError, setIsMediaPeriodEndTimeError] = useState(false);
    let [mediaShedulePeriodId, setMediaShedulePeriodId] = useState('')
    let [currentMediaId, setCurrentMediaId] = useState<Guid>("");
    let [playNowMediaSchedule, setPlayNowMediaSchedule] = useState<PlayNowMediaSchedule[]>([])
    let [isShowDeletePlayNowMediaScheduleModal, setIsShowDeletePlayNowMediaScheduleModal] = useState(false)

    let [groupedMedia, setGroupedMedia] = useState<GroupPlayNowMedia[]>([])
    let [isShowGroupModal, setIsShowGroupModal] = useState(false)
    let [mediaGroups, setMediaGroups ] = useState<Option<Guid>[]>([]);
    let [selectedMediaGroup, setSelectedMediaGroup] = useState<Guid>('');
    let [mediaGroupAction, setMediaGroupAction] = useState<ModalAction>("nothing");
    let [groupName, setGroupName] = useState("");
    let [isGroupNameError, setIsGroupNameError] = useState(false);
    let [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    let [groupModalAction, setGroupModalAction] = useState<ModalAction>("nothing");
    let [itemIdForAction, setItemIdForAction] = useState<Guid>("");
    let [mediaIdForAction, setMediaIdForAction] = useState<Guid>("");

    let [checkedItems, setCheckedItems] = useState<CheckedItems>({});

    // Edit functionality state
    let [editingPeriodId, setEditingPeriodId] = useState<Guid | null>(null);
    let [editPeriodName, setEditPeriodName] = useState<string>('');
    let [editPeriodStart, setEditPeriodStart] = useState<string>('');
    let [editPeriodEnd, setEditPeriodEnd] = useState<string>('');
    let [editPeriodStartTime, setEditPeriodStartTime] = useState<string>('');
    let [editPeriodEndTime, setEditPeriodEndTime] = useState<string>('');
    let [isEditPeriodEndTimeError, setIsEditPeriodEndTimeError] = useState<boolean>(false);
    let [isEditPeriodEndError, setIsEditPeriodEndError] = useState<boolean>(false);


    let mediaItemsPerPage = 12;

    useEffect(() => {
        let getData = async () => {
            setIsLoading(true);
            await Promise.all([updateGroupedMediaList(),updateMedia(), updateGroups(), fetchPlayNowInfo()]);
            setIsLoading(false);
        };

        getData();
    }, []);

    useEffect(() =>{
        const initialCheckedItems: CheckedItems = {};
        groupedMedia.forEach(item => {
            if(checkedItems[item.id] === undefined){
                initialCheckedItems[item.id] = true
            } else {
                initialCheckedItems[item.id] = checkedItems[item.id]
            }
        });
        setCheckedItems(initialCheckedItems);
    },[groupedMedia])

    const updateGroupedMediaList = async () => {
        setIsLoading(true);
        let listMediaRequest = await getGroupedPlayNowMedia(listId);
        if (listMediaRequest.type == "succes") {
            setGroupedMedia(listMediaRequest.data.items);
            setTotalDuration(calculateTotalDuration(listMediaRequest.data.items));
        }
        setIsLoading(false);
    }

    const fetchPlayNowInfo = async () => {
        setIsLoading(true);
        let playNowRequest = await getPlayNowList(listId);
        if (playNowRequest.type == "succes") {
            setPlayNow(playNowRequest.data.data);
        }
        setIsLoading(false);
    }

    const calculateTotalDuration = (items: GroupPlayNowMedia[]) => {
        let arr: number[] = []
        items.map(el => {
            if(el.singleMedia){
                arr.push(el.singleMedia.durationMs)
            }
            if(el.groupMedia){
                el.groupMedia.map(el2 => {
                    arr.push(el2.durationMs)
                })
            }
        })
        return arr.reduce((a, b) => a+b, 0)
    }

    const updateMedia = async () => {
        let mediaRequest = await getMedia();
        if (mediaRequest.type == "succes") {
            setMedia(mediaRequest.data.medias);
        }
    }

    const updateGroups = async () => {
        let response = await getGroupsForPlayNowMedia(listId);
        if( response.type === "succes") {
            let t = response.data.items.map( el => {
                return {
                    label: el.name,
                    value: el.id
                }
            })
            setMediaGroups(t);
        }
    }

    const getFilteredBySearch = () => {
        return searchString === ''
            ? media
            : media.filter(it => !!it.name && it.name.toLowerCase().includes(searchString.toLowerCase()))
    }

    const getMediaItemsToDisplay = () => {
        var filteredBySearch = getFilteredBySearch();
        let startIndex = (currentPage - 1) * mediaItemsPerPage;
        let finishIndex = startIndex + mediaItemsPerPage;
        return filteredBySearch.slice(startIndex, finishIndex)
    }

    const getNumberOfSelectedMedia = (id: string): number | undefined => {
        var element = selectedMedia.find(it => it.id === id);
        return element && element.index;
    }

    const addOrRemove = (id: Guid) => {
        var selectedMediaCopy = [...selectedMedia];
        for (var i = 0; i < selectedMediaCopy.length; i++) {
            if (selectedMediaCopy[i].id === id) {
                selectedMediaCopy.splice(i, 1);
                for (var decreaseId = i; decreaseId < selectedMediaCopy.length; decreaseId++) {
                    selectedMediaCopy[decreaseId].index = selectedMediaCopy[decreaseId].index - 1;
                }
                setSelectedMedia(selectedMediaCopy);
                return;
            }
        }

        var maxIndex = selectedMediaCopy.length === 0 ? 0 : Math.max(...selectedMediaCopy.map(it => it.index));
        selectedMediaCopy.push({ id: id, index: maxIndex + 1 });
        setSelectedMedia(selectedMediaCopy);
    }

    const closeModal = () => {
        setSelectedMedia([]);
        setSearchString("");
        setShowMediaModal(false);
    }

    const addMedia = async () => {
        let request: PlayNowListAddMediaRequest = { mediaIds: selectedMedia.map(it => it.id) };
        let result = await addMediaToPlayNowList(listId, request);
        await updateGroupedMediaList();
        closeModal();
    }

    const enableSkin = async (mediaId: Guid) => {
        setIsLoading(true);
        await enableSkinPlayNowMedia(listId, mediaId);
        await updateGroupedMediaList();
        setIsLoading(false);
    }

    const disableSkin = async (mediaId: Guid) => {
        setIsLoading(true);
        await disableSkinPlayNowMedia(listId, mediaId);
        await updateGroupedMediaList();
        setIsLoading(false);
    }

    const deleteMedia = async () => {
        setIsLoading(true)
        await playNowListDeleteMedia(listId, itemIdForAction);
        await updateGroupedMediaList();
        setIsLoading(false)
        closeConfirmModal()
    }

    const renderMediaLibraryItem = (item: { mediaType: MediaType, number?: number, previewLink: string, fileName: string, id: string }) => {
        const className = `media-elem ${item.number && "checked"}`
        return <div key={item.id} className={className} onClick={() => addOrRemove(item.id)}>
            <span className="check-elem">{item.number}</span>
            {renderMediaTypePreviewModal(item.mediaType, item.previewLink)}
            <p className="media-title">{item.fileName}</p>
        </div>
    }

    const renderMediaTypePreview = (media: PlayNowListMedia) => {
        switch(media.type){
            case MediaType.Image : return <img className="sortable__item-img" src={media.url} alt="" />
            case MediaType.Video : return <img className="sortable__item-img" src={media.url} alt="" />
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="sortable__item-img" src={media.url} alt="" />;
            case MediaType.YoutubeLive : return <img className="sortable__item-img" src={media.url} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
            case MediaType.HiveStack : return <img className="media-img-preview" src={hiveStackIMG} alt="" />;
        }
    }

    const renderMediaTypePreviewModal = (type: MediaType, url: string) => {
        switch(type){
            case MediaType.Image : return <img className="media-img-preview" src={url} alt="" />
            case MediaType.Video : return <img className="media-img-preview" src={url} alt="" />
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="media-img-preview" src={url} alt="" />;
            case MediaType.YoutubeLive : return <img className="media-img-preview" src={url} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
            case MediaType.HiveStack : return <img className="media-img-preview" src={hiveStackIMG} alt="" />;
        }
    }

    const openScheduleModal = async (mediaId:Guid) => {
        setIsLoading(true);
        setCurrentMediaId(mediaId);
        await updatePlayNowMediaSchedule(mediaId);
        setIsShowScheduleModal(true);
        setIsLoading(false)
    }

    const closeScheduleModal = async () => {
        setIsShowScheduleModal(false);
        setCurrentMediaId("");
        setMediaPeriodName('');
        setIsMediaPeriodNameError(false);
        setMediaPeriodStart('');
        setIsMediaPeriodStartError(false);
        setMediaPeriodEnd('');
        setIsMediaPeriodEndError(false);
        setMediaPeriodStartTime('');
        setIsMediaPeriodEndTimeError(false);
        setMediaPeriodEndTime('');
        setIsMediaPeriodEndTimeError(false);
        await updateGroupedMediaList()
    }

    const updatePlayNowMediaSchedule = async (mediaId?: Guid) => {
        setIsLoading(true)
        let id = mediaId ? mediaId : currentMediaId;
        let result = await getPlayNowMediaSchedule(listId, id);
        if(result.type === "succes") {
            setPlayNowMediaSchedule(result.data.items)
        }
        setIsLoading(false)
    }

    const saveMediaSchedule = async () => {
        let isError = false;
        if(mediaPeriodName === '') {
            setIsMediaPeriodNameError(true)
            isError = true
        }

        if(mediaPeriodStart === '') {
            setIsMediaPeriodStartError(true)
            isError = true
        }

        if(mediaPeriodEnd === '') {
            setIsMediaPeriodEndError(true)
            isError = true
        }

        if(new Date(mediaPeriodEnd) < new Date(mediaPeriodStart)){
            setIsMediaPeriodEndError(true)
            isError = true
        }

        if(mediaPeriodStartTime !== ''){
            if(mediaPeriodEndTime === ''){
                setIsMediaPeriodEndTimeError(true)
                isError = true
            } else {
                let [hoursStart, minutesStart] = mediaPeriodStartTime.split(":").map(Number);
                let [hoursEnd, minutesEnd] = mediaPeriodEndTime.split(":").map(Number);
                const startMinutes = hoursStart * 60 + minutesStart;
                const endMinutes = hoursEnd * 60 + minutesEnd;

                if(endMinutes <= startMinutes){
                    setIsMediaPeriodEndTimeError(true)
                    isError = true
                }
            }
        }
        
        if(isError) return

        let request:PlayNowMediaMediaScheduleRequest = {
            name: mediaPeriodName,
            start: mediaPeriodStart,
            end: mediaPeriodEnd,
            startTime: mediaPeriodStartTime,
            endTime: mediaPeriodEndTime
        }

        setIsLoading(true);

        let result = await addPlayNowMediaSchedule(request, listId, currentMediaId);
        if(result.type === "succes") {
            await updatePlayNowMediaSchedule();
        }

        setMediaPeriodName('');
        setMediaPeriodStart('');
        setMediaPeriodEnd('')
        setMediaPeriodStartTime('');
        setMediaPeriodEndTime('');
        setIsLoading(false);

    }

    const showDeletePlayNowMediaScheduleModal = (periodId: Guid) => {
        setIsShowDeletePlayNowMediaScheduleModal(true);
        setMediaShedulePeriodId(periodId);
    }

    const hideDeletePlayNowMediaScheduleModal = () => {
        setIsShowDeletePlayNowMediaScheduleModal(false);
        setMediaShedulePeriodId('')
    }

    const removePlayNowMediaSchedulePeriod = async () => {
        await deletePlayNowMediaSchedule(listId, currentMediaId, mediaShedulePeriodId);
        await updatePlayNowMediaSchedule();
        setIsShowDeletePlayNowMediaScheduleModal(false);
    }

    const startEditingPeriod = (period: PlayNowMediaSchedule) => {
        setEditingPeriodId(period.id);
        setEditPeriodName(period.name);
        setEditPeriodStart(moment(period.start).format('YYYY-MM-DD'));
        setEditPeriodEnd(moment(period.end).format('YYYY-MM-DD'));
        setEditPeriodStartTime(period.startTime ? period.startTime : '');
        setEditPeriodEndTime(period.endTime ? period.endTime : '');
        setIsEditPeriodEndTimeError(false);
        setIsEditPeriodEndError(false);
    }

    const discardEditPeriod = () => {
        setEditingPeriodId(null);
        setEditPeriodName('');
        setEditPeriodStart('');
        setEditPeriodEnd('');
        setEditPeriodStartTime('');
        setEditPeriodEndTime('');
        setIsEditPeriodEndTimeError(false);
        setIsEditPeriodEndError(false);
    }

    const acceptEditPeriod = async () => {
        // Validate input values
        let isError = false;
        setIsEditPeriodEndTimeError(false);
        setIsEditPeriodEndError(false);
        
        if(editPeriodName === '') {
            isError = true;
        }

        if(editPeriodStart === '') {
            isError = true;
        }

        if(editPeriodEnd === '') {
            isError = true;
        }

        if(new Date(editPeriodEnd) < new Date(editPeriodStart)){
            setIsEditPeriodEndError(true);
            isError = true;
        }

        if(editPeriodStartTime !== ''){
            if(editPeriodEndTime === ''){
                setIsEditPeriodEndTimeError(true);
                isError = true;
            } else {
                let [hoursStart, minutesStart] = editPeriodStartTime.split(":").map(Number);
                let [hoursEnd, minutesEnd] = editPeriodEndTime.split(":").map(Number);
                const startMinutes = hoursStart * 60 + minutesStart;
                const endMinutes = hoursEnd * 60 + minutesEnd;

                if(endMinutes <= startMinutes){
                    setIsEditPeriodEndTimeError(true);
                    isError = true;
                }
            }
        }
        
        if(isError) return;

        setIsLoading(true);

        // Remove old period and add updated one
        await deletePlayNowMediaSchedule(listId, currentMediaId, editingPeriodId!);
        
        // Add the updated period
        let request: PlayNowMediaMediaScheduleRequest = {
            name: editPeriodName,
            start: editPeriodStart,
            end: editPeriodEnd,
            startTime: editPeriodStartTime,
            endTime: editPeriodEndTime
        }

        await addPlayNowMediaSchedule(request, listId, currentMediaId);
        await updatePlayNowMediaSchedule();
        
        // Clear edit state
        setEditingPeriodId(null);
        setEditPeriodName('');
        setEditPeriodStart('');
        setEditPeriodEnd('');
        setEditPeriodStartTime('');
        setEditPeriodEndTime('');
        setIsEditPeriodEndTimeError(false);
        setIsEditPeriodEndError(false);
        setIsLoading(false);
    }

    const duplicatePeriod = async (period: PlayNowMediaSchedule) => {
        setIsLoading(true);

        let request: PlayNowMediaMediaScheduleRequest = {
            name: `${period.name} (Copy)`,
            start: moment(period.start).format('YYYY-MM-DD'),
            end: moment(period.end).format('YYYY-MM-DD'),
            startTime: period.startTime || '',
            endTime: period.endTime || ''
        }

        await addPlayNowMediaSchedule(request, listId, currentMediaId);
        await updatePlayNowMediaSchedule();
        setIsLoading(false);
    }

    const renderPlayNowMediaScheduleRow = (periods: PlayNowMediaSchedule[]) => {
        return periods.map( it => {
            const isEditing = editingPeriodId === it.id;
            
            return <tr key={it.id}>
                <td>
                    {isEditing ? (
                        <input 
                            type="text"
                            className="form-control"
                            value={editPeriodName}
                            onChange={(e) => setEditPeriodName(e.target.value)}
                            disabled={isLoading}
                        />
                    ) : (
                        it.name
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <input 
                            type="date"
                            className="form-control"
                            value={editPeriodStart}
                            onChange={(e) => setEditPeriodStart(e.target.value)}
                            disabled={isLoading}
                        />
                    ) : (
                        formatDate(it.start)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <input 
                                type="date"
                                className={`form-control ${isEditPeriodEndError ? 'error' : ''}`}
                                value={editPeriodEnd}
                                onChange={(e) => {
                                    setEditPeriodEnd(e.target.value);
                                    setIsEditPeriodEndError(false);
                                }}
                                disabled={isLoading}
                            />
                            {isEditPeriodEndError && <span className="error" style={{fontSize: '12px'}}>End date must be later than start date</span>}
                        </>
                    ) : (
                        formatDate(it.end)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <input 
                            type="time"
                            className="form-control"
                            value={editPeriodStartTime}
                            onChange={(e) => setEditPeriodStartTime(e.target.value)}
                            disabled={isLoading}
                        />
                    ) : (
                        formatTimeOnly(it.startTime)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <input 
                                type="time"
                                className={`form-control ${isEditPeriodEndTimeError ? 'error' : ''}`}
                                value={editPeriodEndTime}
                                onChange={(e) => {
                                    setEditPeriodEndTime(e.target.value);
                                    setIsEditPeriodEndTimeError(false);
                                }}
                                disabled={isLoading}
                            />
                            {isEditPeriodEndTimeError && <span className="error" style={{fontSize: '12px'}}>End time must be later than start time</span>}
                        </>
                    ) : (
                        formatTimeOnly(it.endTime)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <IconButton type="save" tooltipText="Accept" onClick={acceptEditPeriod} disabled={isLoading} />
                            <IconButton type="cross" tooltipText="Discard" onClick={discardEditPeriod} disabled={isLoading} />
                        </>
                    ) : (
                        <>
                            <IconButton type="edit" tooltipText="Edit" onClick={() => startEditingPeriod(it)} />
                            <IconButton type="copy" tooltipText="Duplicate" onClick={() => duplicatePeriod(it)} />
                            <IconButton type="delete" tooltipText="Delete" tooltipPosition="left" onClick={()=>{
                                showDeletePlayNowMediaScheduleModal(it.id)}
                            }/>
                        </>
                    )}
                </td>
            </tr>
        })
    }

    const renderPlayNowMediaScheduleInTable = (periods: PlayNowMediaSchedule[]) => {
        return periods.map( it => {
            return <div key={it.id} style={{width:"285px"}}>
                <p>{it.name} {formatDate(it.start)} - {formatDate(it.end)}&nbsp;{formatTimeOnly(it.startTime)} - {formatTimeOnly(it.endTime)}</p>
            </div>
        })
    }

    const showGroupModal = (action: ModalAction, item?: GroupPlayNowMedia) => {
        if(item){
            setGroupName(item.name)
            setItemIdForAction(item.id)
        }
        setMediaGroupAction(action)
        setIsShowGroupModal(true)
    }

    const hideGroupModal = () => {
        setSelectedMediaGroup("")
        setIsGroupNameError(false)
        setMediaGroupAction("nothing")
        setGroupName("")
        setItemIdForAction("")
        setMediaIdForAction("")
        setIsShowGroupModal(false)
    }

    const createNewGroupForMedia = async () => {
        if(groupName === "") {
            setIsGroupNameError(true);
            return;
        }
        
        let request = {name:groupName};
        setIsLoading(true)
        await createGroupForPlayNowMedia(request, listId)
        await updateGroups()
        setIsLoading(false)
        hideGroupModal()
    }

    const updateGroupName = async () => {
        if(groupName === "") {
            setIsGroupNameError(true);
            return;
        }
        
        let request = {name:groupName};
        setIsLoading(true)
        await changeGroupNameForPlayNowMedia(request, itemIdForAction, listId)
        await updateGroups()
        await updateGroupedMediaList()
        setIsLoading(false)
        hideGroupModal()
    }

    const onChangeSelectedMediaGroup = (group: SingleValue<Option<Guid>>) => {
        if(group){
            setSelectedMediaGroup(group.value);
        } else {
            setSelectedMediaGroup('');
        }
    }

    const handleCheckboxChange = (id: string) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };


    const saveGroupForMedia = async () => {
        let request: GroupForPlayNowMediaRequest = {
            groupId: selectedMediaGroup ? selectedMediaGroup : null,
        }
        setIsLoading(true)
        await updateGroupForPlayNowMedia(request, listId, mediaIdForAction)
        await updateGroupedMediaList()
        setIsLoading(false)
        hideGroupModal()
    }

    const showConfirmModal = (id: Guid, action: ModalAction) => {
        setItemIdForAction(id);
        setGroupModalAction(action)
        setIsShowConfirmModal(true);
    }

    const closeConfirmModal = () => {
        setItemIdForAction("");
        setGroupModalAction("nothing")
        setIsShowConfirmModal(false);
    }

    const cloneGroup = async () => {
        setIsLoading(true)
        await cloneGroupPlayNowMedia(listId, itemIdForAction)
        await updateGroups()
        await updateGroupedMediaList()
        setIsLoading(false)
        closeConfirmModal()
    }

    const deleteGroup = async () => {
        setIsLoading(true)
        await removeGroupPlayNowMedia(listId, itemIdForAction)
        await updateGroups()
        await updateGroupedMediaList()
        setIsLoading(false)
        closeConfirmModal()
    }

    const cloneMedia = async () => {
        setIsLoading(true)
        await cloneGroupedPlayNowMedia(listId, itemIdForAction)
        await updateGroupedMediaList()
        setIsLoading(false)
        closeConfirmModal()
    }

    const getReorderedIdsForRequest = (medias: GroupPlayNowMedia[]) => {
        let requestObject:ReorderedPlayNowIds = {ids:[]}

        medias.forEach((elem) => {
            if(elem.singleMedia){
                requestObject.ids.push(elem.id)
            } 
            if(elem.groupMedia) {
                requestObject.ids.push(...elem.groupMedia.map(it => it.id))
            }
        })

        return requestObject
    }

    const sendReorderedIds = async () => {
        setIsLoading(true)
        setTimeout(async () => {
            await reorderGroupPlayNowMedia(getReorderedIdsForRequest(groupedMedia), listId);
            await updateGroupedMediaList()
            setIsLoading(false)
        }, 200)
    }

    const onDropMediaInGroup = async (newOrderedMedia: PlayNowListMedia[], myNum: number) => {
        let arr = [...groupedMedia]
        arr[myNum].groupMedia = newOrderedMedia
        setGroupedMedia(arr)
    }

    const renderGroupMedia = (medias: GroupPlayNowMedia[]) => {
        return medias.map((item, index) => {

            if(item.singleMedia){
                return renderMedia([item.singleMedia])
            }

            if(item.groupMedia){
                return <>
                    <tr className="no-hover" key={item.id}>
                        <td colSpan={11} className="group-media-block" style={{textAlign:'left', padding:"0 0 15px 30px"}}>
                        <div className="group-title">
                            {item.name}
                            <IconButton tooltipText="Clone" type="copy" onClick={() => showConfirmModal(item.id, "clone")}/>
                            <IconButton tooltipText="Edit" type="edit" onClick={() => showGroupModal("update", item)}/>
                            <IconButton tooltipText="Delete" type="delete" onClick={() => showConfirmModal(item.id, "delete")}/>
                            <div className="d-inline-flex justify-content-end" style={{marginLeft:30}}>
                                <label htmlFor={`group-${item.id}`} className="checkbox-control" >
                                    <input 
                                        id={`group-${item.id}`} 
                                        className="checkbox" 
                                        type="checkbox" 
                                        checked={!!checkedItems[item.id]}
                                        onChange={() => handleCheckboxChange(item.id)}
                                    />
                                    <span className="checkbox-bg"></span>
                                    <span className="checkbox-cursor"></span>
                                </label>
                                <span className="current-status">&nbsp;Expand</span>
                            </div>
                        </div>
                        <ReactSortable
                            disabled={false}
                            list={item.groupMedia}
                            setList={(newState) => {onDropMediaInGroup(newState, index)}}
                            onEnd={sendReorderedIds}
                            tag="tbody"
                            filter={'.no-sort'}
                            animation={150}
                            fallbackOnBody={true}
                            swapThreshold={0.65}
                        >
                            {renderMedia(item.groupMedia)}
                        </ReactSortable>
                        </td>
                    </tr>
                </>
            }
        })
    }

    let globalMediaIndex = 1
    const renderMedia = (medias: PlayNowListMedia[]) => {
        return medias.map((item) => {
            return <tr className={`sortable__item`} key={item.id}>
            <td>{addLeadingZero(globalMediaIndex++, 2)}</td>
            <td>{renderMediaTypePreview(item)}</td>
            <td>{item.name}</td>
            <td style={{width:"6%"}}>{renderMediaType(item.type)}</td>
            <td>{item.taxonomiesCategoryName}</td>
            <td>{formatDuration(item.durationMs)}</td>
            <td>{renderPlayNowMediaScheduleInTable(item.schedule)}</td>
            <td>
                <IconButton tooltipText="Clone" type="copy" onClick={() => {showConfirmModal(item.id, "cloneMedia")}} />
                <IconButton tooltipText="Set Group" type="folder" onClick={() => {showGroupModal("set"); setMediaIdForAction(item.id)}} />
                {item.isTriggeringSkin
                    ? <IconButton tooltipText="With Skin" type="mosaic" onClick={() => {disableSkin(item.id)}}/> 
                    : <span className="no-skin-svg-icon">
                        <IconButton tooltipText="No Skin" type="mosaic" onClick={() => {enableSkin(item.id)}}/>
                </span>}
                <IconButton tooltipText="Schedule" type="clock" onClick={() => {openScheduleModal(item.id)}} />
                <IconButton tooltipText="Delete" type="delete" onClick={() => showConfirmModal(item.id, "deleteMedia")} />
            </td>
        </tr>
        })
    }

    return (
        <InnerLayout
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="playNowList">
            <>
             <h1 style={{'paddingTop':'45px'}}>{playNow?.name}</h1>
                <div className="d-flex justify-content-end align-items-center gap15 mb-20 pt-50">
                    <Button color="green" label="Create Group" onClick={() => {showGroupModal("create")}} />
                    <Button color="green" label="Add Media" onClick={() => setShowMediaModal(true)} />
                </div>

                <div className="duration-all">Total duration: {formatDuration(totalDuration)}</div>

                <table className="table modal-table media-list-table">
                    <thead>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>Name</td>
                            <td style={{width:"6%"}}>Type</td>
                            <td>Media Category</td>
                            <td>Duration</td>
                            <td>Schedule</td>
                            <td></td>
                        </tr>
                    </thead>
                    <ReactSortable
                        list={groupedMedia}
                        setList={(newState) => {setGroupedMedia(newState)}}
                        onEnd={sendReorderedIds}
                        tag="tbody"
                        animation={150}
                        fallbackOnBody={true}
                        swapThreshold={0.65}
                    >
                        {renderGroupMedia(groupedMedia)}
                    </ReactSortable>
                </table>

                <CenterModal
                    title="Media"
                    show={showMediaModal}
                    onRequestClose={closeModal}
                >
                    <>
                        <div className={`d-flex justify-content-between align-items-center mb-40 `}>
                            <Search value={searchString} onChangeValue={setSearchString} />
                        </div>
                        <div className="media-library">
                            {getMediaItemsToDisplay().map(
                                it => renderMediaLibraryItem(
                                    {
                                        mediaType: it.mediaType,
                                        fileName: it.name,
                                        previewLink: it.previewLink,
                                        id: it.id,
                                        number: getNumberOfSelectedMedia(it.id)
                                    }))}
                        </div>

                        <Pagination activePage={currentPage} pagesCount={getPagesCount(getFilteredBySearch().length, mediaItemsPerPage)} changePaginationPage={setCurrentPage} />

                        <div className="modal-btn-group">
                            <Button color="green" label="Add" onClick={addMedia} />
                            <Button color="gray" label="Cancel" onClick={closeModal} />
                        </div>
                    </>
                </CenterModal>

                <CenterModal title="Media Schedule" show={isShowScheduleModal} onRequestClose={closeScheduleModal}>
                    <div className="mosaic-period-wrapper">
                        <div className="mosaic-period-inputs">
                            <div>
                                <FormInput 
                                    errorMessage = "Please enter name"
                                    id = "period_name"
                                    isError = {isMediaPeriodNameError}
                                    title = "Name"
                                    onChangeValue = {(v) => {setMediaPeriodName(v); setIsMediaPeriodNameError(false)}}
                                    value = {mediaPeriodName}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="start">Start Date</label>
                                <input 
                                    type="date" 
                                    className={`form-control ${isMediaPeriodStartError ? "error" : ""}`}  
                                    name="" 
                                    id="start" 
                                    onChange = {(v) => {setMediaPeriodStart(v.target.value); setIsMediaPeriodStartError(false)}}
                                    value={mediaPeriodStart}
                                />
                                {isMediaPeriodStartError && <span className="error">Please select start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends">End Date</label>
                                <input 
                                    type="date" 
                                    className={`form-control ${isMediaPeriodEndError ? "error" : ""}`}  
                                    name="" 
                                    id="ends" 
                                    onChange = {(v) => {setMediaPeriodEnd(v.target.value); setIsMediaPeriodEndError(false)}}
                                    value={mediaPeriodEnd}
                                    min={mediaPeriodStart}
                                    disabled={!!!mediaPeriodStart}
                                />
                                {isMediaPeriodEndError && <span className="error">End period should be later than start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="start-time">Start Time</label>
                                <input 
                                    type="time" 
                                    className={`form-control`}  
                                    name="" 
                                    id="start-time" 
                                    onChange = {(v) => {setMediaPeriodStartTime(v.target.value)}}
                                    value={mediaPeriodStartTime}
                                />
                                {isMediaPeriodStartError && <span className="error">Please select start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends-time">End Time</label>
                                <input 
                                    type="time" 
                                    className={`form-control ${isMediaPeriodEndTimeError ? "error" : ""}`}  
                                    name="" 
                                    id="ends-time" 
                                    onChange = {(v) => {setMediaPeriodEndTime(v.target.value); setIsMediaPeriodEndTimeError(false)}}
                                    value={mediaPeriodEndTime}
                                />
                                {isMediaPeriodEndTimeError && <span className="error">End period should be later than start period</span>}
                            </div>
                            <div className="">
                                <Button color="green" label="Add" onClick={saveMediaSchedule}/>
                            </div>
                        </div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>Start Date</td>
                                    <td>End Date</td>
                                    <td>Start Time</td>
                                    <td>End Time</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {renderPlayNowMediaScheduleRow(
                                    playNowMediaSchedule.sort((a, b) => a.name.localeCompare(b.name))
                                )}
                            </tbody>
                        </table>
                    </div>
                </CenterModal>

                <RightModal title={`${mediaGroupAction === "create" ? "Add" : "Set"} Group`} show={isShowGroupModal} onRequestClose={hideGroupModal}>
                    <FormRow>
                        {mediaGroupAction === "set" && <><label>Groups</label>
                        <Select 
                            options={mediaGroups}
                            classNamePrefix={`select`}
                            onChange={onChangeSelectedMediaGroup} 
                            isClearable={true}
                        /></>}
                        {(mediaGroupAction === "create" || mediaGroupAction === "update") && <FormInput 
                            errorMessage = "Please enter Group Name"
                            id = "media_group_name"
                            isError = {isGroupNameError}
                            title = "Group Name"
                            onChangeValue = {(v) => {setGroupName(v); setIsGroupNameError(false)}}
                            value = {groupName}
                        />}
                    </FormRow>
                    <div className="modal-btn-group">
                        {mediaGroupAction === "set" && <Button color="green" label="Save" onClick={saveGroupForMedia}/>}
                        {mediaGroupAction === "update" && <Button color="green" label="Save" onClick={updateGroupName}/>}
                        {mediaGroupAction === "create" && <Button color="green" label="Add" onClick={createNewGroupForMedia}/>}
                        <Button color="gray" label="Cancel" onClick={hideGroupModal}/>
                    </div>
                </RightModal>  

                <SmallModal show={isShowDeletePlayNowMediaScheduleModal} onRequestClose={hideDeletePlayNowMediaScheduleModal}> 
                    <p>That you want to delete Media Schedule Period</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={hideDeletePlayNowMediaScheduleModal}/>
                        <Button color="green" label="Yes" onClick={removePlayNowMediaSchedulePeriod}/>
                    </div>
                </SmallModal>

                <SmallModal show={isShowConfirmModal} onRequestClose={closeConfirmModal}> 
                    {groupModalAction === "clone" && <p>That you want to {`${groupModalAction}`} Group?</p>}
                    {groupModalAction === "delete" && <p>That you want to {`${groupModalAction}`} Group?</p>}
                    {groupModalAction === "cloneMedia" && <p>That you want to clone Media?</p>}
                    {groupModalAction === "deleteMedia" && <p>That you want to delete Media?</p>}
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeConfirmModal}/>
                        {groupModalAction === "cloneMedia" && <Button color="green" label="Yes" onClick={cloneMedia}/>}
                        {groupModalAction === "clone" && <Button color="green" label="Yes" onClick={cloneGroup}/>}
                        {groupModalAction === "delete" && <Button color="green" label="Yes" onClick={deleteGroup}/>}
                        {groupModalAction === "deleteMedia" && <Button color="green" label="Yes" onClick={deleteMedia}/>}
                    </div>
                </SmallModal>
                
                <GlobalSpinner isShow={isLoading} />

            </>
        </InnerLayout>
    );
}

export default CurrentPlayListMedia;